import * as React from "react"
 
import { cn } from "../../../@/lib/utils"
import { Field } from "formik"
import { FieldWrapper } from "../Additional/FieldWrapper"
import { Label } from "@radix-ui/react-label"
 
export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}
 
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, name, required, ...props }, ref) => {
    return (
      <FieldWrapper name={name ?? ""}>
        <Label className="block text-md font-medium">
          {props.title}
          {required && <span className="text-red-500 ml-1">*</span>}
        </Label>
        <Field
          name={name}
          type={type}
          className={cn(
            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder: text-grey focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          ref={ref}
          {...props}
        />
      </FieldWrapper>
    )
  }
)
Input.displayName = "Input"
 
export { Input }
